import { render, staticRenderFns } from "./PosmLogo.vue?vue&type=template&id=48b13105"
import script from "./PosmLogo.vue?vue&type=script&lang=js"
export * from "./PosmLogo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports